import React from 'react';
import { Icon, Text } from '@highereducation/hen-ui';

export interface ErrorMessageProps {
  message: string;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className = '',
}) => (
  <div
    role='alert'
    className={`flex items-center gap-1 text-sm text-error-500 ${className}`}
  >
    <Icon icon='circle-alert' size='sm' aria-hidden />
    <Text variant='b5' tag='span'>
      {message}
    </Text>
  </div>
);
